<template>
  <div class="form-group row">
    <label for="lm-select" class="col-sm-2 col-form-label">{{label}}</label>
    <div class="col-sm-10">
      <select
        v-model="select"
        :class="{'is-invalid': v.$error}"
        :disabled="disabled"
        class="form-control"
        id="lm-select"
        >
        <option disabled value="">{{options.disabledOption}}</option>
        <option v-for="(option, index) of options.content" :key="index">{{option}}</option>
      </select>
      <p class="invalid-feedback" v-if="!v.required"> {{ $t('field_required')}} </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number, Boolean],
      default: ''
    },
    v: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    disabled: Boolean,
    label: String
  },
  computed: {
    select: {
      get () {
        return this.value
      },
      set (value) {
        this.v.$touch()
        this.$emit('input', value)
      }
    }
  }
}
</script>
